export type TNativeChannelSplitterNode = ChannelSplitterNode;
